const actionTypes =  {
    SESSION_WRONG_DOMAIN: "SESSION_WRONG_DOMAIN",
    SESSION_ME: "SESSION_ME",
    SESSION_INITIALIZED: "SESSION_INITIALIZED",
    SET_SECTION: "SET_SECTION",
    INIT_TENANT: "INIT_TENANT",
    INIT_CACHE: "INIT_CACHE",
}

export default actionTypes;